import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (state.url.includes('/auth/login')) {
      if (this.authService.isAuthenticated()) {
        this.router.navigate(['/dashboard']);
        return false;
      } else {
        return true;
      }
    } else {
      if (!this.authService.isAuthenticated()) {
        const freeRoutes = ['/auth/reset-password', '/auth/sign-otp'];
        if (freeRoutes.includes(state.url)) {
          return true;
        } else {
          this.router.navigate(['/auth/login']);
          return false;
        }
      } else {
        return true;
      }
    }
  }
}
